export async function hapticsImpactHeavy() {
    await vibrate([20, 10, 20]);
}


export async function hapticsImpactMedium() {
    await vibrate(20);
}


export async function hapticsImpactLight() {
    await vibrate(10);
}


export async function vibrate(duration) {
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
        navigator.vibrate(duration); // simulate heavier pattern
    }
}
